<p-table
	[value]="paginationResult.entities"
	[lazy]="true"
	(onLazyLoad)="loadData($event)"
	[rows]="paginationRequest.pageSize"
	[totalRecords]="paginationResult.filteredEntities"
	[rowsPerPageOptions]="[10, 20, 30, 40, 50]"
	[paginator]="true"
	[(selection)]="selectedEntities"
	[loading]="loading"
	[rowHover]="true"
	[showCurrentPageReport]="true"
	dataKey="name"
	currentPageReportTemplate="{first} - {last} {{ 'table.of' | translate }} {totalRecords}"
	class="custom-table"
	styleClass="p-datatable-striped"
>
	<!-- #region TABLE TITLE DEFINITION -->
	<ng-template pTemplate="caption">
		<div class="d-flex align-items-center justify-content-center text-uppercase mb-5 table-title" [ngClass]="{'custom-title-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-title-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
			{{ 'tableManagement.breakdown.breakdownReason.title' | translate }}
		</div>
	</ng-template>
	<!-- #endregion TABLE TITE DEFINITION -->

	<!-- #region TABLE COLUMN DEFINITION -->
	<ng-template pTemplate="header">
		<tr [ngClass]="{'custom-header-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-header-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
			<!-- SELECT -->
			<th class="checkbox-column">
				<div class="d-flex justify-content-center">
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</div>
			</th>

			<!-- REASON -->
			<th pSortableColumn="reason">
				<div class="d-flex align-items-center h-100">
					<!-- COLUMN TITLE -->
					<div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
						{{ 'tableManagement.breakdown.breakdownReason.reason' | translate }}
					</div>

					<!-- COLUMN SORT && FILTER ICONS -->
					<div class="d-flex align-items-center h-100">
						<p-sortIcon field="reason"></p-sortIcon>
						<p-columnFilter
							field="reason"
							type="text"
							matchMode="contains"
							placeholder="{{ 'general.search' | translate }}"
							display="menu"
							[showMatchModes]="false"
							[showOperator]="false"
							[showAddButton]="false"
						></p-columnFilter>
					</div>
				</div>
			</th>

			<!-- ACTIVE -->
			<th pSortableColumn="disabled">
				<div class="d-flex align-items-center h-100">
					<!-- COLUMN TITLE -->
					<div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
						{{ 'general.active' | translate }}
					</div>

					<!-- COLUMN SORT && FILTER ICONS -->
					<div class="d-flex align-items-center h-100">
						<p-sortIcon field="disabled"></p-sortIcon>
						<p-columnFilter
							field="disabled"
							type="boolean"
							display="menu"
							[showApplyButton]="false"
						></p-columnFilter>
					</div>
				</div>
			</th>
		</tr>
	</ng-template>
	<!-- #endregion TABLE COLUMN DEFINITION -->

	<!-- #region TABLE BODY -->
	<ng-template pTemplate="body" let-breakdownReason>
		<tr class="p-selectable-row custom-rows" [ngClass]="{'custom-rows-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-rows-medium': authenticationService?.user?.fontSize === 'MEDIUM'}" (dblclick)="editDialog(breakdownReason)">
			<!-- SELECT -->
			<td>
				<div class="d-flex justify-content-center">
					<p-tableCheckbox [value]="breakdownReason"></p-tableCheckbox>
				</div>
			</td>

			<!-- REASON -->
			<td>
				{{ breakdownReason.reason }}
			</td>

			<!-- ACTIVE -->
			<td>
				<div class="d-flex justify-content-center align-items-center">
					<i
						class="pi"
						[ngClass]="{
							'true-icon pi-check-circle': !breakdownReason.disabled,
							'false-icon pi-times-circle': breakdownReason.disabled,
						}"
					></i>
				</div>
			</td>
		</tr>
	</ng-template>
	<!-- #endregion TABLE BODY -->

	<!-- #region TABLE EMPTY MESSAGE -->
	<ng-template pTemplate="emptymessage">
		<tr>
			<td colspan="5" class="p-0">
				<div class="d-flex align-items-center justify-content-center h-100 p-5 custom-empty-message" i18n>
					{{ 'table.tableEmptyMessage' | translate }}!
				</div>
			</td>
		</tr>
	</ng-template>
	<!-- #endregion TABLE EMPTY MESSAGE -->

	<!-- #region TABLE FOOTER -->
	<ng-template pTemplate="footer">
		<tr>
			<td colspan="5" class="p-0">
				<div class="d-flex flex-row align-items-center p-3 gap-3">
					<!-- ADD accessory BUTTON -->
					@if (isCreateGranted) {
						<app-table-add-button
							[text]="'tableManagement.breakdown.breakdownReason.title' | translate"
							(btnClick)="create()"
						></app-table-add-button>
					}

					<!-- CHANGE STATUS BUTTON -->
					<app-table-change-status-button
						(btnClick)="changeStatus()"
						[isDisabled]="selectedEntities.length === 0 || !isDisabledGranted"
					></app-table-change-status-button>

					<!-- EXCEL BUTTON -->
					<app-table-excel-button class="buttonTableExcel" (btnClick)="exportExcel()"></app-table-excel-button>
				</div>
			</td>
		</tr>
	</ng-template>
	<!-- #endregion TABLE FOOTER -->
</p-table>

<!-- CHANGE STATUS DIALOG -->
@if (showStatusDialog) {
	<div>
		<app-change-status-shared
			[items]="'tableManagement.breakdown.breakdownReason.title' | translate"
			[display]="true"
			[service]="breakdownReasonService"
			[entitiesList]="selectedEntities"
			(return)="refreshList($event)"
			(close)="closeStatusDialog($event)"
		></app-change-status-shared>
	</div>
}

<!-- BREAKDOWN REASON FORM -->
<app-breakdown-reason-form></app-breakdown-reason-form>
